<template>
  <transition name="cycleFromLeft" mode="out-in">
    <div class="helpAlternate">
      <div class="helpAlternate__close" @click="dismissComponent(config.id)">
        <span>&times;</span>
      </div>
      <div v-if="config.image" class="helpAlternate__logo">
        <img :src="config.image" alt="Desivero"/>
      </div>
      <div v-if="config.shortText" class="helpAlternate__description" v-html="config.shortText">
      </div>
      <div v-if="config.fullText" class="helpAlternate__caption" v-html="config.fullText">
      </div>
      <div class="helpAlternate__quickLinks">
        <div v-for="link in quicklinks" :class="getLinkClass(link.name)">
          <a :href="link.href" target="_blank">
            <img :src="link.imgPath" alt=""/>
          </a>
          <div v-if="link.hasNumber">
            <span>0297190019</span>
          </div>
        </div>
      </div>
      <div class="helpAlternate__img">
        <img :src="returnBasePath('/assets/img/shared/corner-man.png')" alt="Desivero"/>
      </div>
    </div>
  </transition>
</template>

<script>
  export default{
    props: ['dataObj', 'currentVariant'],
    data(){
      return {
        config: {},
        variant: this.currentVariant,
        hasInfo: false,
        quicklinks: [
          {
            "name": "mail",
            "imgPath": WIZARD.assetsBasePath + "/assets/img/shared/icon-mail.png",
            "type": "link",
            "href": "https://www.desivero.com/contatti"
          },
          {
            "name": "chat",
            "imgPath": WIZARD.assetsBasePath + "/assets/img/shared/icon-chat.png",
            "type": "link",
            "href": "https://www.smartsuppchat.com/widget?key=75428593c4d0726947a4a0163da30f962c90958b&vid=8Gn4b8DkfXixKBbF2Q6WVIEwt4jk8xZgs524431026032018&group=&lang=it&pageTitle=Desivero%20%E2%80%93%20soluzioni%20per%20il%20bagno%2C%20il%20riscaldamento%20e%20la%20climatizzazione&pageUrl=https%3A%2F%2Fwww.desivero.com%2F&domain=www.desivero.com&referer="
          },
          {
            "name": "phone",
            "imgPath": WIZARD.assetsBasePath + "/assets/img/shared/icon-phone.png",
            "type": "link",
            "href": "tel:0297190019",
            "hasNumber": false
          }
        ]
      }
    },
    watch: {
      currentVariant(){
        this.variant = this.currentVariant;
      }
    },
    computed: {
      hasOverlay(){
        return this.config.info && this.config.info.type == 'overlay';
      }
    },
    methods: {
      checkPhoneResolution(){
        var windowWidth = $(window).innerWidth();
        if (windowWidth >= 768) {
          this.quicklinks[2].href = 'javascript:void(0)';
          this.quicklinks[2].hasNumber = true;
        }
        else {
          this.quicklinks[2].href = 'tel:0297190019';
          this.quicklinks[2].hasNumber = false;
        }
      },
      getLinkClass(name){
        return 'helpAlternate__quickLinks__item helpAlternate__quickLinks__item--' + name;
      },
      openInfoOverlay(){
        var vm = this;
        if (vm.config.info.type == 'overlay') {
          vm.$emit('open-overlay', vm.config.info);
        }
      },
      beforeEnter(){
        $('.helpAlternate__answers__item').addClass('slideLeft-enter');
      },
      enter(){
        $('.helpAlternate__answers__item').removeClass('slideLeft-enter');
      },
      leave(){
      },
      afterLeave(){
      },
      updateProps(){
        //Update component data when component is mounted or updated
        this.config = this.dataObj;
      },
      updateParentProps(){
        // Emits response from @retrieveNextStep(), precedently saved in Vue store, to parent component @App.vue
        var vm = this;
        var config = vm.$store.state.tempConfigObj;
        if (config) {
          vm.$emit('update-props', config);
          this.$forceUpdate();
        }
      },
      retrieveNextStep(questionId, answerId, isDisabled){
        if (!isDisabled) {
          // Make AJAX call to retrieve next help node
          // @helpId {integer}:
          //    is the current node ID
          // @answerId {integer}:
          //    is the chosen answer ID
          var vm = this;
          for (var i = 0; i < vm.config.answers.length; i++) {
            vm.config.answers[i].disabled = true;
          }
          vm.makeNextCall(questionId, answerId, function () {
            vm.updateParentProps();
          })
        }
      },
      dismissComponent(questionId){
        var vm = this;
        vm.makeDismissCall(questionId, function () {
          vm.updateParentProps();
        })
      }
    },
    mounted(){
      var vm = this;
      vm.updateProps();
      vm.checkPhoneResolution();
      $(window).on('resize', vm.checkPhoneResolution);
    },
    updated(){
      var vm = this;
      vm.updateProps();
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/help/Alternate.vue